//In case of error, note that cssId prop was added to the DeckNav

//Function to aid in setting up the navigation pages
//(After user selects a subject from the Homepage)

//Function for passing in 2 parameters
    //name of the face card array found in Folder:DeckCardOverview, and the title that will
    //be displayed as a subheader above the card elements

//Imports
import './CVPairDeckNavFunct.css';
import { Link } from 'react-router-dom';
import Footer from '../../../Components/Footer/Footer';

//one folder up so use ../
//if two folders away use ../../

export default function CVPairDeckNavFunct({faceCard = [], title_input}) {

  
    return (    
    
    <div>
        <div>
            <h1 className = "subheader-CVPair">{title_input}</h1>
        </div>

        <div className="CardContainer-CVPair">
        {faceCard.map((a) => (

          <div key={a.id} className="Card-CVPair" id={a.id}>
            <Link to={a.Link}> 
                <img src={a.Image} alt={a.Title} className="CardImage-CVPair" />
                <h3 id={a.cssId} className="cardTitle-CVPair">{a.Title}</h3>
                <div className="CardDifficulty-CVPair">{a.Difficulty}</div>
                <p className="cardDescription-CVPair">{a.Description}</p>
            </Link>
          </div>
        ))}
        </div>
        <Footer/>
    </div>
  );
}




  

